import { MessageKanriModel } from "../data/message-kanri-model";
import { CommonStorageKey } from "../const/common-storage-key";

/**
 * メッセージに関するユーティリティクラスです。
 */
export class MessageUtil {

  public static getMessage(msg: string, msgParams: string[] = []): string {
    for (let i = 0; i < msgParams.length; i++) {
      msg = msg.replace('{' + i + '}', msgParams[i]);
    }
    return msg;
  }

  public static getStorageMessage(msgId: string, msgParams: string[] = []): string {
    let messageKanriList: MessageKanriModel[] = JSON.parse(sessionStorage.getItem(CommonStorageKey.MESSAGEKANRILIST));

    for (let i = 0; i < messageKanriList.length; i++) {
      if (messageKanriList[i].messageId == msgId) {
        if (messageKanriList[i].messageIdHyoujiHuragu == '1') {
          return msgId + ":" + this.getMessage(messageKanriList[i].messageHonbun, msgParams);
        } else {
          return this.getMessage(messageKanriList[i].messageHonbun, msgParams);
        }
      }
    }
  }

  // 課題No18 start
  public static getMessageSpecify(messageKanriList: MessageKanriModel[] = [], msgId: string, msgParams: string[] = []): string {

    for (let i = 0; i < messageKanriList.length; i++) {
      if (messageKanriList[i].messageId == msgId) {
        if (messageKanriList[i].messageIdHyoujiHuragu == '1') {
          return msgId + ":" + this.getMessage(messageKanriList[i].messageHonbun, msgParams);
        } else {
          return this.getMessage(messageKanriList[i].messageHonbun, msgParams);
        }
      }
    }
  }
  // 課題No18 end
}



// WEBPACK FOOTER //
// ./src/app/modules/shared/utility/message-util.ts